<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ number ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canExport">
        <dx-button text="Export" stylingMode="outlined" type="normal" [disabled]="isExporting"
            (onClick)="exportClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoicePurchaseOrderAction.SaveAsDraft)">
        <dx-button text="Save As Draft" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoicePurchaseOrderAction.SaveAsDraft)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoicePurchaseOrderAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoicePurchaseOrderAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoicePurchaseOrderAction.Submit)">
        <dx-button text="Submit" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoicePurchaseOrderAction.Submit)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoicePurchaseOrderAction.Cancel)">
        <dx-button text="Cancel PO" type="danger" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoicePurchaseOrderAction.Cancel)" class="ms-2" />
    </dxi-item>
</dx-toolbar>